<template>
  <Popup :ref="(el) => popup = el"
         :title="$t('labels.withdrawal')"
         @onClose="hide"
  >
    <div v-if="account">
      <div class="main-wallet__top">
        <div class="main-wallet__main-info">
          <div class="main-wallet__icon">
            <img :src="helper.currencyIcon(account.currency)">
          </div>
          <div class="main-wallet__info">
            <div class="main-wallet__sum">
              <span>{{ numberFormatter.formatNumber(account.sumWithoutInsurance) }}</span> {{account.currency}}
            </div>
            <div class="main-wallet__wallet">
                    <span class="main-wallet__wallet-address for-copy">
                        {{ account._wallet ? truncateAddress(account._wallet.address) : '' }}
                    </span>
              <span>(USDT TRC20)</span>
              <CopyButton :value="account._wallet?.address"></CopyButton>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2 pt">
        <div class="col-sm-12 d-flex justify-content-between align-items-center pb-0 p-sm">
          <label for="amount" class="col-form-label text-capitalize-first">{{ helper.trans("labels.amount") }} <a class="link" href="#" @click.prevent="form.amount = numberFormatter.formatNumber(availableAmount, account.sum.subunit)"><small>{{ numberFormatter.formatNumber(availableAmount, account.sum.subunit) }}</small></a></label>
        </div>

        <div class="col-sm-12">
          <FormInputWrapper v-slot="parentProps" :errors="getErrors(`amount`)" >
            <input v-model="form.amount"
                   :class="parentProps.class"
                   type="text" class="form-control " id="amount">
          </FormInputWrapper>

        </div>
        <div v-if="feeAmount > 0">
          <small>{{ helper.trans("labels.withdrawal_fee_warning", {fee: numberFormatter.formatNumber(feeAmount, 2), feeCurrency: 'USDT'})   }}</small>
        </div>
      </div>

      <div class="row mt-2 pt">
        <div class="col-sm-12 d-flex justify-content-between align-items-center pb-0 p-sm">
          <label for="address" class="col-form-label text-capitalize-first">{{ helper.trans("labels.address.usdt") }}</label>
          <a  class="link" href="#" @click.prevent="showWhitelist()"><small>{{ helper.trans("labels.edit_whitelist")}}</small></a>
        </div>

        <div class="col-sm-12">
          <FormInputWrapper v-slot="parentProps" :errors="getErrors(`address`)">
            <input v-if="store.getters.getUser?.withdrawalAddress" v-model="form.address" readonly :class="parentProps.class" type="text" class="form-control" id="address">
            <input v-else-if="!account.withdrawalWhitelistsEnabled" v-model="form.address" :class="parentProps.class" type="text" class="form-control" id="address">
            <Multiselect v-else
                         :class="parentProps.class"
                         class="multiselect"
                         v-model="form.address"
                         :options="whitelistAddresses"
                         select-label="Select"
                         deselect-label=""
                         placeholder=""
                         open-direction="bottom"
                         :multiple="false"
                         :searchable="false"
                         :clear-on-select="false"
                         :close-on-select="true"
                         :show-no-results="false"
                         :hide-selected="false"
            >

            </Multiselect>
          </FormInputWrapper>

        </div>
      </div>

      <FormInputWrapper v-slot="parentProps" :errors="getErrors(``)" class="pb">
        <span  :class="parentProps.class"></span>
      </FormInputWrapper>


      <div class="requisites__controls pt">
        <button class="btn" type="button" @click.prevent="hide">
          <span class="text-capitalize-first">{{ $t('button.cancel') }}</span>
        </button>
        <LoaderButton :on-click="save" class="btn btn--accept">
          <span class="text-capitalize-first">{{ $t('button.withdraw') }}</span>
        </LoaderButton>
      </div>
    </div>
    <WithdrawalWhitelistPopup ref="withdrawalWhitelistPopup"/>
  </Popup>
</template>
<script lang="ts">
import {computed, defineComponent, ref} from 'vue'
import {reactive, toRefs} from '@vue/reactivity';
import Popup from "@/apps/public/components/Popup.vue";
import {$t, helper, truncateAddress} from "@/service/CommonHelper";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import {api} from "@/service/APIClient";
import AccountDTO from "@/models/AccountDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/apps/public/components/CopyButton.vue";
import {useStore} from "vuex";
import MoneyDTO from "@/models/MoneyDTO";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import WithdrawalFormDTO from "@/models/form/WithdrawalFormDTO";
import PaginationDTO from "@/models/PaginationDTO";
import Multiselect from "vue-multiselect";
import AccountWithdrawalRequestDTO from "@/models/request/AccountWithdrawalRequestDTO";
import {useNotification} from "@kyvg/vue3-notification";
import WithdrawalWhitelistPopup from "@/apps/public/components/WithdrawalWhitelistPopup.vue";


export default defineComponent({
  methods: {$t},
  emits: ['state:updated'],
  components: {WithdrawalWhitelistPopup, CopyButton, LoaderButton, FormInputWrapper, Popup, Multiselect},
  setup(props, {emit}) {
    const notification = useNotification()
    const store = useStore();
    const popup = ref<InstanceType<typeof Popup> | null>(null)
    const withdrawalWhitelistPopup = ref<InstanceType<typeof WithdrawalWhitelistPopup> | null>(null)

    const state = reactive({
      account: null as AccountDTO|null,
      fee: store.getters.getAppData?.withdrawalFee as MoneyDTO|null,
      errors: {} as ValidationErrorDTO[]|any,
      form: {
        amount: null,
        address: null,
        expenseType: null,
        expenseComment: null,
      } as WithdrawalFormDTO,
      whitelistAddresses: [] as string[]
    });

    const onOkClick = async () => {

      hide()
    }

    const show = async (account: AccountDTO) => {
      state.form = {
        amount: null,
        address: null,
        expenseType: null,
        expenseComment: null,
      }  as WithdrawalFormDTO

      state.account = account
      if (store.getters.getUser?.withdrawalAddress) {
        state.form.address = store.getters.getUser?.withdrawalAddress
      }
      state.errors = [];
      loadWhitelistAddresses()
      state.fee = await api.withdrawalsFee()
      popup.value?.show()
    }

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const feeAmount = computed<number>(() => {
      if (!state.account) {
        return 0;
      }

      const amount = state.fee?.amount

      return amount ? parseFloat(amount) : 0
    })

    const availableAmount = computed(() => {
      if (!state.account) {
        return 0;
      }
      const sum = parseFloat(state.account!.sum.amount);
      const fee = feeAmount?.value
      const insurance = parseFloat(state.account!.insuranceLimitSum.amount);
      if (sum - insurance - fee < 0) {
        return 0;
      }

      return sum - insurance - fee;
    })

    const showWhitelist = () => {
      withdrawalWhitelistPopup.value?.show(state.account!, (enabled: boolean) => {
        if (state.account) {
          state.form.address = null
          loadWhitelistAddresses()
          state.account.withdrawalWhitelistsEnabled = enabled
        }
      });
    }

    const loadWhitelistAddresses = async () => {
      if (!state.account) {
        state.whitelistAddresses = [];
        return;
      }

      const items = (await api.withdrawalWhitelist({limit: 1000, offset: 0} as PaginationDTO, {
        status: 'active',
        accountIds: [state.account.id]
      })).items
      let addresses = [];
      for (const item of items) {
        addresses.push(item.address)
      }

      state.whitelistAddresses = addresses
    }


    const save = async (): Promise<any> => {
      setErrors([]);
      const form = state.form;
      try {
        await api.accountWithdrawalCreate(state.account!.id, {
          ...form,
          amount: form.amount ? form.amount.replaceAll(" ", '') : ''
        } as AccountWithdrawalRequestDTO)
      } catch (e: any) {
        if (e.response && e.request && e.request.status === 400 && e.response.data) {
          setErrors(e.response.data)
        } else {
          console.log(e);
        }
        throw e;
      }

      notification.notify({title: helper.trans('withdrawal.notice.created')});
      hide()
    }

    const hide = () => {
      state.account = null
      popup.value?.hide()
    }

    return {
      ...toRefs(state),
      numberFormatter,
      onOkClick,
      store,
      showWhitelist,
      feeAmount,
      withdrawalWhitelistPopup,
      getErrors,
      popup,
      helper,
      show,
      hide,
      availableAmount,
      save,
      truncateAddress,
    }
  }
})
</script>
